import React, { useState, useEffect } from 'react';
import './BulkActions.css';

const BulkActions = ({
  selectedCount,
  onDelete,
  onActivate,
  onDeactivate,
  onExport,
  onClear,
  loading = false,
  progress = null, // { current: 0, total: 0, action: '' }
  success = null, // { message: '', count: 0 }
  error = null // { message: '' }
}) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  // Show success message
  useEffect(() => {
    if (success) {
      setShowSuccess(true);
      const timer = setTimeout(() => setShowSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  // Show error message
  useEffect(() => {
    if (error) {
      setShowError(true);
      const timer = setTimeout(() => setShowError(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  if (selectedCount === 0 && !showSuccess && !showError) {
    return null; // Don't show toolbar if nothing is selected
  }

  return (
    <>
      {/* Success Notification */}
      {showSuccess && success && (
        <div className="bulk-action-notification bulk-action-success">
          <i className="material-icons">check_circle</i>
          <span>{success.message || `Successfully processed ${success.count || selectedCount} item(s)`}</span>
          <button onClick={() => setShowSuccess(false)}>
            <i className="material-icons">close</i>
          </button>
        </div>
      )}

      {/* Error Notification */}
      {showError && error && (
        <div className="bulk-action-notification bulk-action-error">
          <i className="material-icons">error</i>
          <span>{error.message || 'An error occurred'}</span>
          <button onClick={() => setShowError(false)}>
            <i className="material-icons">close</i>
          </button>
        </div>
      )}

      {/* Progress Bar */}
      {progress && progress.total > 0 && (
        <div className="bulk-action-progress">
          <div className="bulk-progress-info">
            <span>{progress.action || 'Processing'}...</span>
            <span>{progress.current} / {progress.total}</span>
          </div>
          <div className="bulk-progress-bar">
            <div 
              className="bulk-progress-fill"
              style={{ width: `${(progress.current / progress.total) * 100}%` }}
            />
          </div>
        </div>
      )}

      {/* Bulk Actions Toolbar */}
      {selectedCount > 0 && (
        <div className="bulk-actions-toolbar">
          <div className="bulk-actions-info">
            <span className="bulk-selection-count">
              <i className="material-icons">check_circle</i>
              {selectedCount} {selectedCount === 1 ? 'item' : 'items'} selected
            </span>
            {loading && (
              <span className="bulk-loading-indicator">
                <i className="material-icons spinning">hourglass_empty</i>
                Processing...
              </span>
            )}
          </div>
          
          <div className="bulk-actions-buttons">
            {onActivate && (
              <button
                className="bulk-action-btn bulk-action-activate"
                onClick={onActivate}
                disabled={loading}
                title="Activate selected items"
              >
                {loading ? (
                  <i className="material-icons spinning">hourglass_empty</i>
                ) : (
                  <i className="material-icons">check_circle</i>
                )}
                Activate
              </button>
            )}
            
            {onDeactivate && (
              <button
                className="bulk-action-btn bulk-action-deactivate"
                onClick={onDeactivate}
                disabled={loading}
                title="Deactivate selected items"
              >
                {loading ? (
                  <i className="material-icons spinning">hourglass_empty</i>
                ) : (
                  <i className="material-icons">block</i>
                )}
                Deactivate
              </button>
            )}
            
            {onExport && (
              <button
                className="bulk-action-btn bulk-action-export"
                onClick={onExport}
                disabled={loading}
                title="Export selected items"
              >
                <i className="material-icons">download</i>
                Export
              </button>
            )}
            
            {onDelete && (
              <button
                className="bulk-action-btn bulk-action-delete"
                onClick={onDelete}
                disabled={loading}
                title="Delete selected items"
              >
                {loading ? (
                  <i className="material-icons spinning">hourglass_empty</i>
                ) : (
                  <i className="material-icons">delete</i>
                )}
                Delete
              </button>
            )}
            
            {onClear && (
              <button
                className="bulk-action-btn bulk-action-clear"
                onClick={onClear}
                disabled={loading}
                title="Clear selection"
              >
                <i className="material-icons">close</i>
                Clear
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BulkActions;

